import React from 'react';
import './crm-ui.scss';

function CrmBadge({ children, tone = 'neutral', className = '', ...props }) {
  return (
    <span className={`crm-badge crm-badge--${tone} ${className}`.trim()} {...props}>
      {children}
    </span>
  );
}

export default CrmBadge;
